import { createSlice } from '@reduxjs/toolkit';

const INIT_STATE = {
  company: null,
  companyInit: null,
  enforceOtpConfig: false
};

const { actions, reducer } = createSlice({
  name: 'app',
  initialState: INIT_STATE,
  reducers: {
    setCompany: (state, { payload }) => {
      state.company = payload;
    },
    setCompanyInit: (state, { payload }) => {
      state.companyInit = payload;
    },
    setEnforceOtpConfig(state, { payload }) {
      state.enforceOtpConfig = payload;
    }
  }
});

export const { setCompany, setCompanyInit, setEnforceOtpConfig } = actions;

export default reducer;
